import Repository from "./repository"

export default {
    /**
     * S21001_お申し込み履歴表示
     *
     * @param {object} params リクエストパラメータ
     */
    get(params) {
        return Repository.get('/api/s210-order-history/view', { params: params })
    },
    // S21002 メモ更新処理
    edit(sAcceptNo, sOrderNote) {
        return Repository.post('/api/s210-order-history/order-note/edit', {
            'accept_no': sAcceptNo,
            'order_note': sOrderNote
        })
    },
    /**
     * S21003 申請中製品取得処理
     *
     * @param {object} params リクエストパラメータ
     */
    getProcessingNewOrder(params) {
        return Repository.get('/api/s210-order-history/plan/processing-new-order', { params: params })
    }
}
